/* Swym → fj:wishlist:updated bridge, plus <fj-wishlist-count> for the header badge.
   Counts shopper saves only; Swym's auto-wishlist items (Saved For You) are excluded. */
class FjSwymWishlistCount {
  constructor(swat) {
    this.swat = swat;
    this.update();

    const events = swat.JSEvents || {};
    [events.addedToWishlist, events.removedFromWishlist]
      .filter(Boolean)
      .forEach((name) => swat.evtLayer.addEventListener(name, () => this.update()));
  }

    update() {
    this.swat.fetchLists({
      callbackFn: (lists) => {
        const count = lists.reduce(
          (total, list) => total + (list.listcontents || [])
            .filter((item) => item.source !== 'auto-wishlist').length,
          0
        );
        this.dispatch(count);
      },
      errorFn: () => {}
    });
  }

  dispatch(count) {
    const send = () => document.dispatchEvent(
      new CustomEvent('fj:wishlist:updated', { bubbles: true, detail: { count } })
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', send, { once: true });
    } else {
      send();
    }
  }
}

class FjWishlistCount extends HTMLElement {
  connectedCallback() {
    this.onUpdate = (event) => {
      const { count } = event.detail;
      this.textContent = count;
      this.closest('[data-fj-wishlist-badge]')?.toggleAttribute('hidden', count === 0);
    };
    document.addEventListener('fj:wishlist:updated', this.onUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('fj:wishlist:updated', this.onUpdate);
  }
}

if (!customElements.get('fj-wishlist-count')) {
  customElements.define('fj-wishlist-count', FjWishlistCount);
}

if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push((swat) => new FjSwymWishlistCount(swat));